function cleanText(value) {
  return typeof value === "string" ? value.trim() : "";
}

function isValidEmail(value) {
  const email = cleanText(value);
  return (
    email.length <= 128 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  );
}

export function isStrongClientPassword(value) {
  const password = String(value || "");
  return (
    password.length >= 8 &&
    password.length <= 32 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}

export function normalizeRegistrationCities(raw) {
  const rows = Array.isArray(raw?.cities) ? raw.cities : [];
  const seen = new Set();

  return rows.flatMap((row) => {
    const id = cleanText(row?.iref);
    const name = cleanText(row?.name);
    if (!id || !name || seen.has(id)) return [];
    seen.add(id);

    const postalCode = String(row?.zipCode || "").trim();
    return [{
      id,
      name,
      label:
        postalCode && postalCode !== "0"
          ? `${name} (${postalCode})`
          : name,
    }];
  });
}

export function normalizeRegistrationCounties(raw) {
  const rows = Array.isArray(raw?.counties) ? raw.counties : [];
  const seen = new Set();

  return rows.flatMap((row) => {
    const id = cleanText(row?.iref);
    const name = cleanText(row?.name);
    if (!id || !name || seen.has(id)) return [];
    seen.add(id);
    return [{ id, name, label: name }];
  });
}

export function validateClientRegistrationForm(form) {
  const errors = {};
  const firstName = cleanText(form?.firstName);
  const lastName = cleanText(form?.lastName);
  const email = cleanText(form?.email);
  const countyId = cleanText(form?.county?.id);
  const cityId = cleanText(form?.city?.id);
  const password = String(form?.password || "");
  const confirmation = String(form?.passwordConfirmation || "");

  if (!firstName) errors.firstName = "required";
  if (!lastName) errors.lastName = "required";
  if (!email) {
    errors.email = "required";
  } else if (!isValidEmail(email)) {
    errors.email = "email";
  }
  if (!countyId) errors.county = "required";
  if (!cityId) errors.city = "required";
  if (!password) {
    errors.password = "required";
  } else if (!isStrongClientPassword(password)) {
    errors.password = "password";
  }
  if (!confirmation) {
    errors.passwordConfirmation = "required";
  } else if (password !== confirmation) {
    errors.passwordConfirmation = "match";
  }

  return errors;
}

export function buildClientRegistrationPayload(form, languageIref) {
  return {
    client: {
      first_name: cleanText(form?.firstName).slice(0, 128),
      last_name: cleanText(form?.lastName).slice(0, 128),
      email: cleanText(form?.email).toLowerCase().slice(0, 128),
      password: String(form?.password || "").slice(0, 32),
      language: cleanText(languageIref),
      person: {
        image: "",
        gender: 9,
        address: {
          city: cleanText(form?.city?.id),
        },
      },
    },
  };
}
